interface IconGasProps {
  size?: number | string;
  color?: string;
  className?: string;
}
/**
 *
 * IconGas
 */
const IconGas = ({ size = 48, color = '#FB8932', className }: IconGasProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_93_9682)">
      <path
        d="M24.5 4.91992C17.24 4.91992 11.38 6.39992 11.38 8.19992V39.7799C11.38 41.5999 17.26 43.0599 24.5 43.0599C31.74 43.0599 37.62 41.5799 37.62 39.7799V8.19992C37.62 6.37992 31.74 4.91992 24.5 4.91992ZM30.44 22.0999C26.76 19.9999 22.26 19.9999 18.58 22.0999C17.52 20.2399 16.46 18.3799 15.4 16.5199C21.04 13.2999 27.98 13.2999 33.62 16.5199C32.56 18.3799 31.5 20.2399 30.44 22.0999Z"
        fill={color}
      />
    </g>
    <defs>
      <clipPath id="clip0_93_9682">
        <rect width="48" height="48" fill="white" transform="translate(0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default IconGas;
